import React from 'react';
import { HeroSection } from '../components/deck/HeroSection';
import { AgentDetectionSection } from '../components/deck/AgentDetectionSection';
import { AIUsageSection } from '../components/deck/AIUsageSection';
import { VendorComparisonSection } from '../components/deck/VendorComparisonSection';
import { CodeIntelligenceSection } from '../components/deck/CodeIntelligenceSection';
import { AIScorecardSection } from '../components/deck/AIScorecardSection';
import { MCPSection } from '../components/deck/MCPSection';
function SectionDivider({
  label
}: {
  label: string;
}) {
  return <div className="flex items-center gap-4 px-6 py-2 max-w-6xl mx-auto" data-id="element-324">
      <div className="flex-1 h-px bg-[#1E2D45]" data-id="element-325" />
      <span className="text-[10px] font-bold tracking-[0.3em] text-[#1E2D45] uppercase" data-id="element-326">
        {label}
      </span>
      <div className="flex-1 h-px bg-[#1E2D45]" data-id="element-327" />
    </div>;
}
export function DeckPage() {
  return <div className="min-h-screen w-full bg-[#080C14]" style={{
    fontFamily: "'Inter', sans-serif"
  }} data-id="element-328">
      <HeroSection data-id="element-329" />
      <SectionDivider label="01 — Detection" data-id="element-330" />
      <AgentDetectionSection data-id="element-331" />
      <SectionDivider label="02 — Usage" data-id="element-332" />
      <AIUsageSection data-id="element-333" />
      <SectionDivider label="03 — Comparison" data-id="element-334" />
      <VendorComparisonSection data-id="element-335" />
      <SectionDivider label="04 — Intelligence" data-id="element-336" />
      <CodeIntelligenceSection data-id="element-337" />
      <SectionDivider label="05 — ROI" data-id="element-338" />
      <AIScorecardSection data-id="element-339" />
      <SectionDivider label="06 — MCP" data-id="element-340" />
      <MCPSection data-id="element-341" />

      {/* Footer */}
      <footer className="py-12 px-6 border-t border-[#1E2D45]" data-id="element-342">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-343">
          <div className="flex items-center gap-3" data-id="element-344">
            <div className="w-7 h-7 rounded-lg bg-cyan-400/10 flex items-center justify-center" data-id="element-345">
              <div className="w-3 h-3 rounded-sm bg-cyan-400" data-id="element-346" />
            </div>
            <span className="text-white font-bold text-sm" data-id="element-347">Waydev</span>
            <span className="text-gray-600 text-sm" data-id="element-348">
              Engineering Intelligence Platform
            </span>
          </div>
          <div className="text-gray-600 text-xs" data-id="element-349">
            Measure AI Agents · Track Autonomous Agent Behavior · Deliver
            Measurable ROI
          </div>
        </div>
      </footer>
    </div>;
}